import { ChoicesMapped } from 'ts/types';
import { iconsAdapter } from 'components/Icons/utils';

export const BusinessCategory = {
  HOME: 'bl_home',
  MOTOR: 'bl_motor',
};

export const TranslationDirectory = {
  HOME_CASE_OPENING: 'caseOpening',
  HOME_FOLLOW_UP: 'common',
  MOTOR: 'synergy',
};

export const QueryParams = {
  CASE_ID: 'case_id',
  PHONE_NUMBER: 'phonenumber',
};

export const DocsDirectory = {
  HOME: 'home',
  MOTOR: 'motor',
};

export const PhoneFields = {
  DIAL_CODE: 'phoneCountryCodeContact',
  NUMBER: 'phoneNumberContact',
};

export const DestinationChoices = {
  CUSTOMER_CHOICE: 'CUSTOMER_CHOICE',
  CUSTOMER_CHOICE_TBD: 'CUSTOMER_CHOICE_TBD',
  NEAREST_GARAGE: 'NEAREST_GARAGE',
};

export const ChoicesMapping = [
  {
    icon: iconsAdapter[DestinationChoices.NEAREST_GARAGE],
    id: DestinationChoices.NEAREST_GARAGE,
    request_suggestions: true,
    text: 'destination_nearest_garage-button_text',
  },
  {
    icon: iconsAdapter[DestinationChoices.CUSTOMER_CHOICE],
    id: DestinationChoices.CUSTOMER_CHOICE,
    must_select_location: true,
    text: 'destination_customer_choice-button_text',
  },
  {
    icon: iconsAdapter[DestinationChoices.CUSTOMER_CHOICE_TBD],
    id: DestinationChoices.CUSTOMER_CHOICE_TBD,
    text: 'destination_customer_choice_tbc-button_text',
  },
] as ChoicesMapped[];

export const UnitDistance = {
  KILOMETERS: 'km',
  MILES: 'mi',
};
